import DateUtils from '../../../utils/DateUtils';
import moment from 'moment';

class FinancialStoriesBL {
  getTiles(accDetails) {
    const tiles = [];
    if (accDetails.type === 'current') {
      tiles.push('microTransactions');
      tiles.push('cashpoint');
      tiles.push('insAndOuts');
    }
    if (accDetails.actionsAvailable['/account/projections']) {
      tiles.splice(1, 0, 'projections');
    }
    if (accDetails.actionsAvailable['/account/pots']) {
      tiles.splice(0, 0, 'savingspot');
    }
    return tiles;
  }
  getTileData(tile) {
    switch (tile) {
      case 'savingspot':
        return {
          id: tile,
          text: '',
          image: '../images/bow/savings-pots-pig.png',
          alt: 'Savings Pot Image',
          btnLabel: '',
        };
      case 'microTransactions':
        return {
          id: tile,
          text: '',
          image: '../images/bow/coffee.png',
          alt: 'Coffee Image',
          btnLabel: '',
        };
      case 'projections':
        return {
          id: tile,
          text: 'Set Up Your Projection',
          image: '../images/b/projection.png',
          alt: 'Slinky Image',
          btnLabel: 'Go to projections ->',
        };
      case 'cashpoint':
        return {
          id: tile,
          text: '',
          image: '../images/bow/chocolate-box.png',
          alt: 'Chocolate Image',
          btnLabel: '',
        };
      case 'insAndOuts':
        return {
          id: tile,
          text: '',
          image: '../images/bow/slinky.png',
          alt: 'Slinky Image',
          btnLabel: '',
        };
    }
  }
  getMonthData(month) {
    let tempDate = moment().subtract(Number(month), 'M').date(1);
    tempDate = moment(tempDate).utcOffset(0);
    tempDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const beginDate = DateUtils.getISODateString(tempDate);
    const endDate = DateUtils.getISODateString(
      moment().subtract(Number(month), 'M').endOf('month')
    );
    return {
      fromDate: beginDate,
      toDate: endDate,
      month: moment(endDate).format('YYYY-MM'),
    };
  }
}

export default new FinancialStoriesBL();
